import parametresDashboardAdmin from "./parametresDashboardAdmin"
export default parametresDashboardAdmin;
